import Vue from 'vue';
import Router from 'vue-router';
import menuMap from '../shared/menuMap';
import can from '../helpers/PermissionHelper';
import store from '../store';
import enums from '../constants/Enums';
Vue.use(Router);

// returns true if trial ended else returns false
function isPlanExpired() {
  const subscriptionData = store.state.subscriptions;
  if (
    subscriptionData?.productHandle === 'trial' &&
    subscriptionData?.trialEndedAt &&
    new Date() > new Date(subscriptionData?.trialEndedAt)
  ) {
    return true;
  }
  return false;
}

function activeConnectors(type = 'activeConnectors') {
  const menu = [];
  store.state[type].forEach(activeConnector => {
    const {
      data: {
        subscriptionDetails: { SOURCE_ID }
      }
    } = activeConnector;
    if (
      activeConnector &&
      activeConnector.data.subscriptionDetails.HAS_CONSENT
    ) {
      if (
        SOURCE_ID !== 'o365_group' &&
        !enums.exportableConnectors.includes(SOURCE_ID) &&
        canViewTeams(SOURCE_ID)
      ) {
        menu.push({});
      }
    }
  });
  return menu;
}
function canViewTeams(sourceId) {
  return sourceId === 'o365_teams' ? can('view', 'teams') : true;
}
export default () => {
  const router = new Router({
    routes: menuMap,
    mode: 'history',
    scrollBehavior() {
      return { x: 0, y: 0 };
    }
  });
  const promise = new Promise(resolve => {
    router.start = resolve;
  });
  router.beforeEach(async (to, from, next) => {
    await promise;
    const hasVault = to.path.indexOf('vault');
    const hasExpire = to.path.indexOf('expire');
    if (hasVault !== -1) {
      if (activeConnectors().length) {
        const hasOrg = to.path.indexOf('org');
        if (
          hasOrg === -1 &&
          !activeConnectors('currentOrgActiveConnectors').length
        ) {
          return next('/404');
        }
        return next();
      }
      return next('/404');
    } else if (to.meta?.permission) {
      const { redirectionMap, validateSomePermissions } = to.meta;
      let firstAvailablePermissionName = '';
      let showBillingAndPlansForLegacyOrg = true;

      // Decide array method
      const method = validateSomePermissions ? 'some' : 'every';

      // Decide redirection type:- dynamic or static
      const isDynamicRedirection = redirectionMap && validateSomePermissions;

      /**
       * Filter permissions based on the selected organization.
       *
       * - 'dynamic' type = permissions for child organizations
       * - If own org is selected → exclude 'dynamic' permissions
       * - If child org is selected:
       *    - and 'dynamic' permissions exist → include only 'dynamic' permissions
       *    - and no 'dynamic' permissions exist → include all permissions
       */
      const hasDynamicPermissions = to.meta.permission.some(({ type }) => type === 'dynamic');

      const permissions = to.meta.permission.filter(({ type }) => {
        const isOwnOrg = store.state.currentlySelectedOrgId === store.state.orgId;

        if (isOwnOrg) {
          // Own org selected: exclude 'dynamic' permissions
          return type !== 'dynamic';
        }

        // Child org selected
        if (hasDynamicPermissions) {
          // Keep only 'dynamic' permissions
          return type === 'dynamic';
        }

        // No 'dynamic' permissions present: keep all
        return true;
      });

      // Perform validation
      const hasPermission = permissions[method](permission => {
        const { action, entity } = permission;
        const permissionName = `can_${action}_${entity}`;

        // For legacy orgs (or orgs having no subscription), we need to hide "Billing and Plans" tab
        if (
          store.state.isCurrentOrgLegacy &&
          store.state.subscriptionPermissions.includes(permissionName)
        ) {
          showBillingAndPlansForLegacyOrg = false;
        }

        // Setting first Available PermissionName
        // if user have that permission available and firstAvailablePermissionName is empty,
        // then set that permissionName as first Available PermissionName
        if (can(action, entity) && !firstAvailablePermissionName) {
          firstAvailablePermissionName = permissionName;
        }

        return can(action, entity);
      });

      if (!showBillingAndPlansForLegacyOrg) {
        next('/404');
      }

      if (hasPermission) {
        // For dynamic redirection : get redirection url from redirectionMap, by passing firstAvailablePermissionName
        return isDynamicRedirection
          ? next(redirectionMap[firstAvailablePermissionName])
          : next();
      } else {
        next('/404');
      }
    } else if (hasExpire !== -1) {
      if (isPlanExpired()) {
        return next();
      }
      next('/404');
    } else {
      next();
    }
  });
  return router;
};
